// src/components/store/sections/hero-banner/HeroV80DiagonalarenaEmeraldMint.tsx
"use client";

import React from "react";
import DynamicHeroVariant from "./DynamicHeroVariant";

export default function HeroV80DiagonalarenaEmeraldMint(props: any) {
  return (
    <DynamicHeroVariant
      variantNumber={80}
      archKey="diagonal_arena"
      archLabel="Diagonal Split Arena"
      palName="EmeraldMint"
      grad="from-emerald-500 via-teal-500 to-emerald-700"
      lightBg="bg-emerald-50"
      textCol="text-emerald-700"
      borderCol="border-emerald-200"
      btnCls="bg-emerald-600 hover:bg-emerald-700"
      {...props}
    />
  );
}
